import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { Button, Loader } from '@smartplatform/ui';
import store from '../../../store';
import { formatDateStr } from '../../../utils';

@observer
export default class List extends React.Component {

	@observable sessions = [];
	@observable isLoading = true;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.sessions = await store.model.Document.find({
			where: {
				docGroup: '0.2F161.2F169.2F16B.',
				date: { gt: new Date(2018, 8, 24) } // начиная с шестого созыва
			},
			include: [
				{ relation: 'refLinks', scope: { fields: ['id'] }},
			],
			order: 'date desc',
		});
		this.isLoading = false;
	};
	
	render() {
		if (this.isLoading) return <Loader />;
		
		return <div>
			<h2>Пленарные заседания в САЗД</h2>
			<div className="sazd-sessions">
				{this.sessions.map(session => <Link key={session.id} to={`/admin/plenarysessions/sazd/${session.id}`}>
					<div className="info">
						<em>{formatDateStr(session.date)}</em> Вопросов: {session.refLinks().length}
					</div>
					<div className="name">{session.name}</div>
				</Link>)}
			</div>
		</div>;
	}
	
}
